import styled from '@emotion/styled';

import { ReportSkillTabContent } from './ReportSkillTabContent';
import { RequestSkillChange } from './RequestSkillChange';
import { RequestSkillTabContent } from './RequestSkillTabContent';
import { useFeedbackDialogStore } from './use-feedback-dialog-store';

import type { FunctionComponent } from 'react';

const ContentContainer = styled.div({
    background: '#FBFBFF',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
});

export const TabContent: FunctionComponent = () => {
    const setFeedbackInformation = useFeedbackDialogStore((state) => state.setFeedbackInformation);
    const currentFeedbackType = useFeedbackDialogStore((state) => state.currentFeedbackType);
    const feedback = useFeedbackDialogStore((state) => state.feedback);

    const onDescriptionChange = (input: string): void => {
        setFeedbackInformation({
            description: input,
        });
    };

    const descriptionValue = feedback[currentFeedbackType].mapOr('', ({ description }) =>
        description.value.mapOr('', (value) => value),
    );

    return (
        <ContentContainer>
            {currentFeedbackType === 'report' && (
                <ReportSkillTabContent descriptionValue={descriptionValue} onDescriptionChange={onDescriptionChange} />
            )}
            {currentFeedbackType === 'change' && (
                <RequestSkillChange descriptionValue={descriptionValue} onDescriptionChange={onDescriptionChange} />
            )}
            {currentFeedbackType === 'request' && (
                <RequestSkillTabContent descriptionValue={descriptionValue} onDescriptionChange={onDescriptionChange} />
            )}
        </ContentContainer>
    );
};
